import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";

export interface IPortalPortfolioImage {
  id: number;
  url: string;
  sortOrder: number;
}

/**
 * Lazily loads an employee's portfolio images for a service when the portfolio
 * dialog is opened. Only fetches while `enabled` is true.
 */
export const useEmployeePortfolioViewer = (
  employeeId: number | undefined,
  serviceId: number | undefined,
  studioId: number | undefined,
  enabled: boolean
) => {
  const canFetch =
    enabled && !!employeeId && employeeId > 0 && !!serviceId && !!studioId;

  // Normalise the base so the final path is always
  // "/Appointments/employees/{employeeId}/portfolio" even if the configured
  // endpoint value accidentally carries a trailing "/portfolio" or slash.
  const employeesBase = endpointsMetadata.appointments.getEmployeePortfolio
    .replace(/\/+$/, "")
    .replace(/\/portfolio$/, "");
  const endpoint = `${employeesBase}/${employeeId}/portfolio?serviceId=${serviceId}&studioId=${studioId}`;

  const { data, isLoading } = useApiQuery<IPortalPortfolioImage[]>({
    queryKey: [
      endpointsMetadata.appointments.getEmployeePortfolio,
      employeeId,
      serviceId,
      studioId,
      "portfolio",
    ],
    endpoint,
    enabled: canFetch,
    globalIsLoading: false,
  });

  return {
    images: data ?? [],
    isLoading,
  };
};
